<div class="inline-installation-info" *ngIf="isLoggedIn$ | async">
  <div *ngIf="currentUser">
    <div class="installation-info-name">
      {{currentUser.installationName || defaultInstallationName}}
    </div>
    <div class="installation-info-description">
      {{currentUser.installationDescription || defaultInstallationDescription}}
    </div>
  </div>
</div>
